<template>
  <div class="nebSimpleRangeSelectDropdown"
    v-loading="loading"
  >
    <div class="nebSimpleRangeSelectDropdown-inputs">
      <neb-form-control label="Min Value"
        width="120px"
      >
        <neb-input type="number" v-model="lower"/>
      </neb-form-control>

      <div class="nebSimpleRangeSelectDropdown-inputs-divider">
        <span>—</span>
      </div>

      <neb-form-control label="Max Value"
        width="120px"
      >
        <neb-input type="number" v-model="upper"/>
      </neb-form-control>
    </div>

    <div class="nebSimpleRangeSelectDropdown-meta">
      <div class="nebSimpleRangeSelectDropdown-meta-label"
        v-if="showMin"
      >
        <span>Minimum value: </span>
        <span class="v">{{ minLabel }}</span>
      </div>

      <div class="nebSimpleRangeSelectDropdown-meta-label"
        v-if="showMax"
      >
        <span>Maximum value: </span>
        <span class="v">{{ maxLabel }}</span>
      </div>

      <div class="nebSimpleRangeSelectDropdown-meta-label"
        v-if="showAvg"
      >
        <span>Average Value: </span>
        <span class="v">{{ avgLabel }}</span>
      </div>
    </div>

    <div class="nebSimpleRangeSelectDropdown-footer">
      <neb-form-control>
        <neb-button type="text"
          @click="onClear"
        >Clear</neb-button>
      </neb-form-control>

      <neb-form-control>
        <neb-button type="textPrimary"
          @click="onSave"
        >Save</neb-button>
      </neb-form-control>
    </div>
  </div>
</template>

<script>
import NebButton from '../Button'
import NebFormControl from '../FormControl'
import NebInput from '../Input'
import { abbreviateNumber } from '@/helpers'
import { isNaN } from 'lodash'

const formatValue = (v, type) => {
  switch (type) {
    case 'int':
      return v.toLocaleString()
    case 'percent':
      return `${v}%`
    case 'seconds':
      return `${v}s`
    default: return v
  }
}

export default {
  name: 'NebSimpleRangeSelectDropdown',

  props: {
    lowerValue: {
      type: [Number, String],
      default: null
    },
    upperValue: {
      type: [Number, String],
      default: null
    },
    showMin: {
      type: Boolean,
      default: false
    },
    showMax: {
      type: Boolean,
      default: false
    },
    showAvg: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    },
    avg: {
      type: Number,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    },
    valueType: {
      type: String,
      default: 'int'
    }
  },

  components: {
    NebButton,
    NebFormControl,
    NebInput
  },

  data: () => ({
    lower: undefined,
    upper: undefined
  }),

  computed: {
    minLabel () {
      return formatValue(abbreviateNumber(this.min), this.valueType)
    },
    maxLabel () {
      return formatValue(abbreviateNumber(this.max), this.valueType)
    },
    avgLabel () {
      return formatValue(abbreviateNumber(this.avg), this.valueType)
    }
  },

  watch: {
    lowerValue: {
      immediate: true,
      handler (newValue) {
        this.lower = newValue
      }
    },
    upperValue: {
      immediate: true,
      handler (newValue) {
        this.upper = newValue
      }
    }
  },

  methods: {
    onSave () {
      const lowVal = parseInt(this.lower)
      const upperVal = parseInt(this.upper)
      this.$emit('save:value', [
        isNaN(lowVal) ? null : lowVal,
        isNaN(upperVal) ? null : upperVal
      ])
    },
    onClear ()  {
      this.lower = undefined
      this.upper = undefined
      this.$emit('save:value', [])
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebSimpleRangeSelectDropdown {
  width: 270px;

  &-inputs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;

    &-divider {
      span {
        font-size: 14px;
      }
    }
  }

  &-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .nebFormControl {
      margin-bottom: 0;
    }
  }

  &-meta {
    padding-bottom: 15px;

    &-label {
      span {
        font-family: $defaultFont;
        font-size: 12px;

        &.v {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
